import { useState } from "react";
import Header from "../Components/Header";
import SidePanel from "../Components/SidePanel";

export default function PageNotFound() {
  const [hideSidepanel, setHideSidePanel] = useState(true);
  const handleHide = (e) => {
    e.preventDefault();
    setHideSidePanel(!hideSidepanel);
  };

  return (
    <>
      <Header Page={""} handleHide={handleHide} />
      {/*<!-- top-right search bar -->*/}
      <SidePanel handleHide={handleHide} hide={hideSidepanel} />
      {/*<!-- Pushable content along with off-canvas opener. -->*/}
      <div className="Page_notFound">
        <img src="./assets/img/page_not_found.jpg" alt="page_not_found" />
      </div>
    </>
  );
}
